import { FeatureFlagsMock as DefaultMocks } from './flags'
import { LocalFeatureFlagsMock } from './flags.local'

export const FeatureFlagsMock = {
  ...DefaultMocks,
  ...LocalFeatureFlagsMock,
}
